<script>
import MinimalLayout from '@/components/layouts/minimal/MinimalLayout';
import getErrorMessage from '@/modules/server-errors';

export default {
  name: 'ResetPassword',
  components: {
    MinimalLayout
  },
  metaInfo() {
    return { title: this.title };
  },
  data() {
    return {
      title: this.$t('Reset My Password'),
      invalid: [],
      isDisabled: false,
      isResetting: false,
      password: '',
      showPassword: false,
      token: this.$route.query.token
    };
  },
  mounted() {
    this.$refs.password.focus();
  },
  methods: {
    handleSubmit() {
      this.isResetting = true;

      // Reset the user's password
      this.$http
        .post('/auth/password/reset', {
          token: this.token,
          password: this.password
        })
        .then(res => {
          this.isDisabled = true;
          this.invalid = [];

          // Store session data
          this.$store.commit('login', res.data.user);

          // Show a message, then redirect
          this.$notify({
            type: 'success',
            title: this.title,
            message: this.$t('Your password has been updated.'),
            onClose: () => this.$router.push({ name: 'Home' })
          });
        })
        .catch(err => {
          const data = err.response.data;
          const status = err.response.status;

          if (status === 400) {
            this.invalid = Array.isArray(data.invalid) ? data.invalid : [];
            this.$notify({
              type: 'error',
              title: this.$t('Error'),
              message: getErrorMessage(data.code),
              onClose: () => {
                // If the token has expired, redirect the user to the recovery form
                if (data.code === 'INVALID_RECOVERY_TOKEN') {
                  this.$router.push({ name: 'RecoverPassword' });
                }
              }
            });
          } else {
            this.$notify({
              type: 'error',
              title: this.$t('Error'),
              message: this.$t('An error occurred. Please try your request again later.')
            });
          }
        })
        .finally(() => (this.isResetting = false));
    }
  }
};
</script>

<template>
  <minimal-layout>
    <el-form
      ref="resetForm"
      :disabled="isDisabled"
      label-position="top"
      @submit.native.prevent="handleSubmit"
    >
      <!-- Password -->
      <el-form-item :class="{ 'is-error': invalid.includes('password') }">
        <el-input
          ref="password"
          v-model="password"
          :placeholder="$t('Password')"
          :type="showPassword ? 'text' : 'password'"
          prefix-icon="el-icon-fa-lock"
          auto-complete="off"
        >
          <a slot="suffix" href="#" @click.prevent="showPassword = !showPassword">
            <i :class="showPassword ? 'el-icon-fa-eye-slash' : 'el-icon-fa-eye'" />
          </a>
        </el-input>
      </el-form-item>

      <!-- Reset button -->
      <el-form-item>
        <el-button
          :loading="isResetting"
          type="primary"
          block
          native-type="submit"
          class="el-button--block"
        >
          {{ $t('Reset My Password') }}
        </el-button>
      </el-form-item>

      <!-- Cancel link -->
      <div class="text-center">
        <small>
          <router-link :to="{ name: 'Login' }">
            {{ $t('Cancel') }}
          </router-link>
        </small>
      </div>
    </el-form>
  </minimal-layout>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

//
// No styles yet
//
</style>
